import { ServerHandler } from "./ServerHandler";
import { DefaultService, OpenAPI, GameInfoAndLikeStatus, LinearOrder, UserTrackingAction } from "../../_genApi/scs";

import { Buffer } from "buffer/";
import _ from "lodash";
import { ListingGameInfo } from "../typedef/ListingGameInfo";

export class ServerUploadGameHandler extends ServerHandler {
	public static readonly DEFAULT_USER_NAME = "bcs_user";

	public static readonly UserGameIdeaSurveyFieldNames = ['email', 'idea', 'genre'];

	_surveyInfo: Map<'email' | 'idea' | 'genre', string> = new Map();

	constructor() {
		super();
		OpenAPI.BASE = this.getServerUrl();
	}

	setO365Ticket(newTicket: string) {
		OpenAPI.TOKEN = newTicket;
	}

	setToken(token: string) {
		console.log('token', token);
		OpenAPI.TOKEN = token;
	}

	getServerUrl() {
		let isLive = process.env.REACT_APP_MODE == 'LIVE';
		console.log("[REACT_APP_MODE]", process.env.REACT_APP_MODE);
		return (isLive)
			? window.location.origin
			: process.env.REACT_APP_DEV_SERVER_URL;
	}

	queryGamesNeedReview() {
		// return DefaultService.postAdminApiBrowseGamesNeedReview({
		// 	"maxCapId": 9999999, //lol what ?
		// 	"numTake": 9999999
		// })
	}

	getCurrentUserInfo() {
		// return DefaultService.getAdminApiInfo();
	}

	async createRole(userDomain: string, adminRole: any) {
		// return DefaultService.postAdminApiAddRoles({
		// 	roles: [adminRole],
		// 	adminDomain: userDomain,
		// })
	}

	async addUser(userDomain: string) {
		// return DefaultService.postAdminApiAddAdminDomain({
		// 	domainName: userDomain
		// })
	}

	async getGameInfo(gameId: number) {
		// let gameInfo = await DefaultService.getAdminApiGameInfo(
		// 	gameId
		// );
		// return gameInfo
	}

	async getGameVersionList(gameId: number) {
		// return DefaultService.postAdminApiGameVersions(
		// 	{gameId}
		// );
	}

	async approveGame(gameId: number, versionIdNeedApprove: number, rating: string) {
		return DefaultService.postAdminApiApproveGameVersion(
			{
				gameId,
				versionId: versionIdNeedApprove,
				rating,
			}
		);
	}

	async rejectGame(gameId: number, versionIdNeedReject: number) {
		// return DefaultService.postAdminApiRejectGameVersion(
		// 	{
		// 		gameId,
		// 		versionId: versionIdNeedReject
		// 	}
		// );
	}

	private async getEarliestVersionForGame(gameId: number) {
		// let versions = await DefaultService.postApiListGameVersions({gameId});

		// let earliestVersion = undefined;
		// let earliestUploadEpoch = -9999999;
		// versions.forEach(each => {
		// 	let uploadAtMS = each.createTime * 1000;
		// 	if (uploadAtMS > earliestUploadEpoch) {
		// 		earliestUploadEpoch = uploadAtMS;
		// 		earliestVersion = each;
		// 	}
		// })
		// let earliestVersionId = Number(earliestVersion?.versionId);
		// return {earliestVersion, earliestVersionId};
	}

	async searchGame(requestBody?: any): Promise<ListingGameInfo[]> {
		// Clean up requestBody by removing 'any' values
		if (requestBody) {
			Object.entries(requestBody).forEach(entries => {
				let [key, val] = entries;
				if (key && val === 'any') {
					delete requestBody[key];
				}
			})
		}

		// Create default order parameter with minId (which was previously passed separately)
		const defaultOrder: LinearOrder = {
			type: LinearOrder.type.LINEAR,
			minId: requestBody?.minId || 0
		};

		// Map parameters to new API signature
		const apiParams = {
			numTake: requestBody?.numTake || 10,
			nameQuery: requestBody?.nameQuery ?? requestBody?.keyword,
			genre: requestBody?.genre,
			order: requestBody?.order || defaultOrder
		};

		const result = await DefaultService.postApiListingGame(apiParams);

		// Map GameInfoAndLikeStatus[] to ListingGameInfo[]
		// Preserve ownerInfo at runtime so createFromListingGameInfos can extract ownerName
		// (the local ListingGameInfo typedef does not declare ownerInfo, hence the cast).
		return result.map(item => ({
			gameInfo: item.gameInfo,
			myStarVoted: item.myStarVoted !== undefined ? item.myStarVoted : -1,
			ownerInfo: (item as any).ownerInfo,
		} as ListingGameInfo));
	}

	async likeGame(gameId: number) {
		return DefaultService.postApiVoteGame({
			gameId,
			numStars: 5
		});
	}

	async viewGame(gameId: number) {
		return Promise.all([
			DefaultService.postApiTrackingViewGame({
				gameId
			}),
			DefaultService.postApiTrackingDoAction({
				gameId,
				action: UserTrackingAction.VIEW_GAME
			})
		])
	}

	async logGamePlayTime(gameId: number, playTimeInSeconds: number) {
		return DefaultService.postApiTrackingPlayedSession({
			gameId,
			playTime: playTimeInSeconds
		});
	}

	async markGameEnd(gameId: number) {
		return DefaultService.postApiTrackingDoAction({
			gameId,
			action: UserTrackingAction.COMPLETE_GAME
		});
	}

	// 	async getZPSToken(accessToken: string, deviceId: string, socialType: SocialType): Promise<{
	// 		zpsToken: string;
	// 		name: any;
	// 		id: number;
	// 		avatar: any
	// 	}> {
	// 		let tokenObj = await DefaultService.postApiGetZpsToken({
	// 			accessToken,
	// 			deviceId,
	// 			socialType
	// 		});
	// 		let zpsToken = tokenObj.token;

	// 		const rawInfo = Buffer.from(zpsToken.split('.')[1], 'base64');
	// 		// @ts-ignore
	// 		const info = JSON.parse(rawInfo);
	// 		return {
	// 			id: parseInt(info?.id || '0'),
	// 			name: info?.displayName || 'Unknown',
	// 			avatar: info?.avatar || 'https://portal-cdn-bco.service.zingplay.com/avatars/cat.png',
	// 			zpsToken,
	// 		}
	//   }

	postApiSendGameIdea(idea: string) {
		// if (!idea) {
		// 	console.error('Cant send empty game idea', idea);
		// 	return;
		// }
		// console.log('sendGameIdea', idea);
		// return DefaultService.postApiSendGameIdea({idea});
	}

	postApiSendEmail(email: string) {
		// if (!email) {
		// 	console.error('Cant send empty email', email);
		// 	return;
		// }
		// console.log('sendEmail', email);
		// return DefaultService.postApiSendEmail({email});
	}

	postApiSendGameGenre(gameGenre: string) {
		// if (!gameGenre) {
		// 	console.error('Cant send empty gameGenre', gameGenre);
		// 	return;
		// }
		// console.log('sendGameGenre', gameGenre);
		// return DefaultService.postApiSendGameGenre({gameGenre});
	}


	clearSurveyInfo(fieldName: 'email' | 'idea' | 'genre') {
		if (!fieldName) return;
		if (!_.includes(ServerUploadGameHandler.UserGameIdeaSurveyFieldNames, fieldName)) {
			console.error('Unrecognized fieldName in clearSurveyInfo: ', fieldName, 'expect one of', ServerUploadGameHandler.UserGameIdeaSurveyFieldNames);
			return;
		}

		if (!this._surveyInfo) return;
		this._surveyInfo.delete(fieldName);
	}

	putSurveyInfo(fieldName: 'email' | 'idea' | 'genre', fieldValue: string) {
		if (!fieldValue) return;
		if (!fieldName) return;
		if (!_.includes(ServerUploadGameHandler.UserGameIdeaSurveyFieldNames, fieldName)) {
			console.error('Unrecognized fieldName in putSurveyInfo: ', fieldName, 'expect one of', ServerUploadGameHandler.UserGameIdeaSurveyFieldNames);
			return;
		}

		if (!this._surveyInfo)
			this._surveyInfo = new Map();

		this._surveyInfo.set(fieldName, fieldValue);
	}

	sendUserGameIdeaSurveyBeaconIfAny() {
		// if (!this._surveyInfo?.size) {
		// 	console.warn('empty surveyInfo to sendBeacon', this._surveyInfo);
		// 	return;
		// }

		// let idea = this._surveyInfo.get("idea");
		// let email = this._surveyInfo.get("email");
		// let genre = this._surveyInfo.get("genre");

		// if (idea)
		// 	DefaultService.sendGameIdeaAsBeacon(idea);

		// if (email)
		// 	DefaultService.sendEmailAsBeacon(email);

		// if (genre)
		// 	DefaultService.sendGameGenreAsBeacon(genre);

		// this._surveyInfo.clear();
	}

	async updateLocalize(
		gameId: number,
		language: string,
		content: string
	): Promise<void> {
		return DefaultService.postApiUpdateLocalize({
			gameId,
			languageId: language,
			content
		});
	}
}
